import { useEffect } from 'react';

const ConfirmationModal = ({ 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Oui", 
  cancelText = "Non",
  confirmVariant = "primary",
  isLoading = false,
  title = "Confirmation"
}) => {
  
  // Empêcher le défilement de la page quand le modal est ouvert
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Gérer la fermeture avec la touche Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && !isLoading) {
        onCancel();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onCancel, isLoading]);

  return (
    <div 
      className="modal fade show d-block" 
      style={{ 
        background: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999 // Z-index très élevé
      }} 
      tabIndex="-1"
    >
      <div 
        className="modal-dialog modal-dialog-centered"
        style={{ zIndex: 10000 }} // Z-index encore plus élevé pour le contenu
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onCancel}
              disabled={isLoading}
              aria-label="Fermer"
            ></button>
          </div>
          <div className="modal-body">
            <p className="mb-0">{message}</p>
            {isLoading && (
              <div className="mt-3">
                <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                <small className="text-muted">Traitement en cours...</small>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button 
              type="button" 
              className={`btn btn-${confirmVariant}`}
              onClick={onConfirm}
              disabled={isLoading}
              autoFocus
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  {confirmText}
                </>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;